// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://xkiiwljlazczfeltfmvf.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhraWl3bGpsYXpjemZlbHRmbXZmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzQyNjI3MjMsImV4cCI6MjA0OTgzODcyM30.fPnXKJF14dy_YxBNeoLh8lgNtNgjDaMlTS5HaOILFnE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);